module.exports = wtr_shared_18_14_0;